// import { drawSvgLine } from "./draw-svg-rope";
// import { deviceIsDesktop } from "../../common/checkDevice";

// let evidenceInited = false;

// export function animateEvidence() {
//   if (evidenceInited) return;
//   evidenceInited = true;

//   const root = document.querySelector(".scene-evidence");
//   if (!root) return;

//   gsap.registerPlugin(ScrollTrigger);

//   const isDesktop = deviceIsDesktop();
//   const prefersReduced = matchMedia?.("(prefers-reduced-motion: reduce)")?.matches;

//   // Utility: promote/demote layers while animating
//   const promote = (sel) => gsap.utils.toArray(sel).forEach((el) => (el.style.willChange = "transform,opacity"));
//   const demote = (sel) => gsap.utils.toArray(sel).forEach((el) => (el.style.willChange = ""));

//   // Prepare rope lines (remove CSS transitions on them in markup if you can)
//   const ropeLines = gsap.utils.toArray(".rope-group line");
//   ropeLines.forEach((ln) => {
//     try {
//       const L = ln.getTotalLength?.() || 0;
//       gsap.set(ln, { strokeDasharray: L, strokeDashoffset: L });
//     } catch {}
//   });

//   if (prefersReduced) {
//     // Minimal, no fancy motion
//     gsap.set(".scene-evidence__img--bottle", { opacity: 1, yPercent: -50 });
//     gsap.set(".scene-evidence__bg--img", { opacity: 0.4 });
//     gsap.set(".scene-evidence__img--stamp", { opacity: 1, y: 0, scale: 1 });
//     gsap.set(".img-ev__container:not(.img-ev__container--hidden)", { opacity: 1, y: 0 });
//     gsap.set(".img-ev__pin:not(.img-ev__pin--hidden)", { opacity: 1, x: 0, y: 0, scale: 1 });
//     gsap.to(ropeLines, { strokeDashoffset: 0, duration: 0.01 });
//     requestAnimationFrame(drawSvgLine);
//     return;
//   }

//   if (isDesktop) {
//     // Initial (transform-only) states
//     gsap.set(".scene-evidence__img--bottle", { opacity: 0, yPercent: -30 }); // was top:"20%"
//     gsap.set(".scene-evidence__bg--img", { opacity: 0 });
//     gsap.set(".scene-evidence__img--stamp", { opacity: 0, y: -94, scale: 2 });
//     // gsap.set(".img-ev__container:not(.img-ev__container--hidden)", { opacity: 1, y: 20 });

//     gsap.set(".img-ev__container:not(.img-ev__container--hidden)", {
//       autoAlpha: 0, // hidden initially
//       y: 20,
//       willChange: "transform,opacity",
//     });
//     gsap.set(".img-ev__pin:not(.img-ev__pin--hidden)", { opacity: 0, x: 20, y: -96, scale: 2 });

//     promote([
//       ".scene-evidence__img--bottle",
//       ".scene-evidence__bg--img",
//       ".scene-evidence__img--stamp",
//       ".img-ev__container:not(.img-ev__container--hidden)",
//       ".img-ev__pin:not(.img-ev__pin--hidden)",
//     ]);

//     // Entry timeline (starts when scene comes into view)
//     gsap
//       .timeline({
//         scrollTrigger: {
//           trigger: ".scene-evidence",
//           start: "top 70%",
//           once: true,
//         },
//       })
//       .to(".scene-evidence__img--bottle", { yPercent: -50, opacity: 1, duration: 0.6, ease: "power2.out" })
//       .to(".scene-evidence__bg--img", { opacity: 0.4, duration: 0.4 }, "<")
//       .to(".scene-evidence__img--stamp", { y: 0, opacity: 1, scale: 1, stagger: 0.05, ease: "bounce.out", duration: 0.6 }, "-=0.3")
//       .to(".img-ev__container:not(.img-ev__container--hidden)", {
//         y: 0,
//         autoAlpha: 1, // brief fade, toggles visibility at 0
//         duration: 0.35,
//         ease: "power2.out",
//         stagger: 0.05,
//         force3D: true,
//         onComplete: function () {
//           // clean up will-change
//           gsap.utils.toArray(".img-ev__container:not(.img-ev__container--hidden)").forEach((el) => (el.style.willChange = ""));
//         },
//       })
//       .to(".img-ev__pin:not(.img-ev__pin--hidden)", { opacity: 1, x: 0, y: 0, scale: 1, ease: "power4.out", stagger: 0.05, duration: 0.3 }, "-=0.8");

//     // Rope reveal (JS-driven, no CSS transitions), plus drawSvgLine once when active
//     let ropeFired = false;
//     const fireRope = () => {
//       if (ropeFired) return;
//       ropeFired = true;
//       requestAnimationFrame(drawSvgLine);
//       gsap.to(ropeLines, { strokeDashoffset: 0, duration: 0.9, ease: "none", stagger: 0.08 });
//     };

//     const pinST = ScrollTrigger.create({
//       trigger: ".scene-evidence",
//       pin: true,
//       start: "top top",
//       end: "+=800",
//       scrub: 0.5, // scrub-light for smoother perf
//       pinReparent: true,
//       anticipatePin: 1,
//       onEnter: fireRope,
//       onEnterBack: fireRope,
//       onRefresh: (st) => {
//         if (st.isActive) fireRope();
//       },
//       onKill: () => {
//         demote([
//           ".scene-evidence__img--bottle",
//           ".scene-evidence__bg--img",
//           ".scene-evidence__img--stamp",
//           ".img-ev__container:not(.img-ev__container--hidden)",
//           ".img-ev__pin:not(.img-ev__pin--hidden)",
//         ]);
//       },
//       // markers: true,
//     });

//     // Debounced resize to redraw the rope layout once
//     let resizeTimer;
//     window.addEventListener("resize", () => {
//       clearTimeout(resizeTimer);
//       resizeTimer = setTimeout(() => {
//         drawSvgLine();
//       }, 150);
//     });
//   } else {
//     // Mobile: no pin, light fade
//     gsap.set(".scene-evidence--wrapper", { y: 100, opacity: 0 });
//     gsap
//       .timeline({
//         scrollTrigger: { trigger: ".scene-evidence", start: "top 70%", once: true },
//       })
//       .to(".scene-evidence--wrapper", { y: 0, opacity: 1, duration: 0.5, ease: "power1.out" });

//     // show ropes immediately
//     gsap.to(ropeLines, { strokeDashoffset: 0, duration: 0.6, ease: "none", stagger: 0.05 });
//     drawSvgLine();
//   }
// }
//
//
//
//
//
//
//
//
//
//

import { drawSvgLine } from "./draw-svg-rope";
import { deviceIsDesktop } from "../../common/checkDevice";

export function animateEvidence() {
  const root = document.querySelector(".scene-evidence");
  if (!root) return;

  gsap.registerPlugin(ScrollTrigger);

  // Shared resize handler for this scene so we don't add multiple listeners
  let resizeHandler = null;

  const setupResizeForRope = () => {
    if (resizeHandler) return; // already set
    let resizeTimer;
    resizeHandler = () => {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(() => {
        drawSvgLine();
      }, 250);
    };
    window.addEventListener("resize", resizeHandler);
  };

  const killResizeHandler = () => {
    if (resizeHandler) {
      window.removeEventListener("resize", resizeHandler);
      resizeHandler = null;
    }
  };

  ScrollTrigger.matchMedia({
    // ==============================
    // DESKTOP WIDTH (>= 768px)
    // ==============================
    "(min-width: 768px)": () => {
      const isDesktopDevice = deviceIsDesktop();
      const isTouch = ScrollTrigger.isTouch === 1;
      const allowPin = isDesktopDevice && !isTouch;

      // ==========================
      // WIDE BUT TOUCH (iPad etc.)
      // → light version, no pin
      // ==========================
      if (!allowPin) {
        gsap.set(".scene-evidence--wrapper", {
          y: 100,
          opacity: 0,
        });

        const tl = gsap
          .timeline({
            scrollTrigger: {
              trigger: ".scene-evidence",
              start: "top 70%",
            },
          })
          .to(".scene-evidence--wrapper", {
            y: 0,
            opacity: 1,
          });

        // Draw rope once + keep it updated on resize
        drawSvgLine();
        setupResizeForRope();

        // cleanup when leaving this media query
        return () => {
          tl.scrollTrigger?.kill();
          tl.kill();
          killResizeHandler();
        };
      }

      // ==========================
      // REAL DESKTOP (non-touch)
      // → full pinned experience
      // ==========================

      // initial states
      gsap.set(".scene-evidence__img--bottle", { opacity: 0, top: "20%" });
      gsap.set(".scene-evidence__bg--img", { opacity: 0 });
      gsap.set(".scene-evidence__img--stamp", { opacity: 0, top: -94, scale: 2 });

      // intro animation (bottle, bg glow, stamp, pins)
      const introTl = gsap
        .timeline({
          scrollTrigger: {
            trigger: ".scene-evidence",
            start: "top 70%",
          },
        })
        .to(".scene-evidence__img--bottle", {
          top: "50%",
          opacity: 1,
        })
        .to(".scene-evidence__bg--img", {
          opacity: 0.4,
        })
        .to(
          ".scene-evidence__img--stamp",
          {
            top: 0,
            opacity: 1,
            scale: 1,
            stagger: 0.05,
            ease: "bounce.out",
          },
          "-=0.5"
        )
        .from(
          ".img-ev__pin:not(.img-ev__pin--hidden)",
          {
            scale: 2,
            ease: "power4.in",
            top: -96,
            right: 20,
            opacity: 0,
            stagger: 0.05,
            duration: 0.3,
          },
          "-=1"
        );

      // Rope logic: ensure we draw once when scene becomes active
      let ropeFired = false;
      const fireRope = () => {
        if (ropeFired) return;
        ropeFired = true;
        requestAnimationFrame(drawSvgLine);
      };

      const pinTl = gsap.timeline({
        onStart: fireRope,
        scrollTrigger: {
          trigger: ".scene-evidence",
          pin: true,
          start: "top top",
          end: "+=800",
          scrub: true,
          onEnter: fireRope,
          onEnterBack: fireRope,
          onRefresh: (st) => {
            if (st.isActive) fireRope();
          },
        },
      });

      // keep ropes aligned when resizing
      setupResizeForRope();

      // cleanup when leaving desktop-width
      return () => {
        introTl.scrollTrigger?.kill();
        introTl.kill();
        pinTl.scrollTrigger?.kill();
        pinTl.kill();
        killResizeHandler();
      };
    },

    // ==============================
    // MOBILE WIDTH (< 768px)
    // ==============================
    "(max-width: 767px)": () => {
      // simple fade-in of the whole board, no pin, lighter on CPU
      gsap.set(".scene-evidence--wrapper", {
        y: 100,
        opacity: 0,
      });

      const tl = gsap
        .timeline({
          scrollTrigger: {
            trigger: ".scene-evidence",
            start: "top 70%",
          },
        })
        .to(".scene-evidence--wrapper", {
          y: 0,
          opacity: 1,
        });

      // draw ropes once for mobile too
      drawSvgLine();
      setupResizeForRope();

      return () => {
        tl.scrollTrigger?.kill();
        tl.kill();
        killResizeHandler();
      };
    },
  });
}

//
//
//
//
//
//
//
// ============================ CHANGED FOR MATCH MEDIA END . WORKING CODE BELOW BEFORE CHANGE

// import { drawSvgLine } from "./draw-svg-rope";
// import { deviceIsDesktop } from "../../common/checkDevice";

// export function animateEvidence() {
//   const isDesktop = deviceIsDesktop();

//   if (isDesktop) {
//     gsap.set(".scene-evidence__img--bottle", { opacity: 0, top: "20%" });
//     gsap.set(".scene-evidence__bg--img", { opacity: 0 });
//     gsap.set(".scene-evidence__img--stamp", { opacity: 0, top: -94, scale: 2 });
//     // gsap.set(".img-ev__container:not(.img-ev__container--hidden)", { opacity: 0, y: 20 });
//     // gsap.set(".img-ev__pin:not(.img-ev__pin--hidden)", { opacity: 0, scale: 2, top: -96, right: 20 });
//     gsap
//       .timeline({
//         // yes, we can add it to an entire timeline!
//         scrollTrigger: {
//           trigger: ".scene-evidence",

//           start: "top 70%", // when the top of the trigger hits the top of the viewport
//           // markers: true,
//         },
//       })
//       .to(".scene-evidence__img--bottle", {
//         top: "50%",
//         opacity: 1,
//       })
//       .to(".scene-evidence__bg--img", {
//         opacity: 0.4,
//       })
//       .to(
//         ".scene-evidence__img--stamp",
//         {
//           top: 0,
//           opacity: 1,
//           // left: 30,
//           scale: 1,
//           stagger: 0.05,
//           ease: Bounce.easeOut,
//         },
//         "-=.5"
//       )
//       // .to(
//       //   ".img-ev__container:not(.img-ev__container--hidden)",
//       //   {
//       //     y: 0,
//       //     opacity: 1,
//       //     stagger: 0.05,
//       //   },
//       //   "-=.3"
//       // )
//       .from(
//         ".img-ev__pin:not(.img-ev__pin--hidden)",
//         {
//           scale: 2,
//           ease: "power4.in",
//           top: -96,
//           right: 20,
//           opacity: 0,
//           stagger: 0.05,
//           duration: 0.3,
//         },
//         "-=1"
//       );

//     // ANIMATIONS

//     let fired = false;
//     const fire = () => {
//       if (fired) return;
//       fired = true;
//       requestAnimationFrame(drawSvgLine);
//     };

//     const tl = gsap.timeline({
//       // timeline-level onStart works only if it starts from progress 0
//       onStart: fire,
//       scrollTrigger: {
//         trigger: ".scene-evidence",
//         pin: true,
//         start: "top top",
//         end: "+=800",
//         scrub: true,
//         // invalidateOnRefresh: true,

//         // Use ST callbacks (these DO exist)
//         onEnter: fire, // scrolling down into it
//         onEnterBack: fire, // scrolling back up into it

//         // If the trigger is already active on refresh (e.g., after resize),
//         // make sure it fires once:
//         onRefresh: (st) => {
//           if (st.isActive) fire();
//         },

//         // markers: true,
//       },
//     });

//     let resizeTimer;

//     if (fired) {
//       window.addEventListener("resize", () => {
//         clearTimeout(resizeTimer);
//         resizeTimer = setTimeout(() => {
//           drawSvgLine();
//         }, 150); // 👈 delay in ms (tweak as needed)
//       });
//     }
//   } else {
//     gsap.set(".scene-evidence--wrapper", {
//       y: 100,
//       opacity: 0,
//     });
//     gsap
//       .timeline({
//         // yes, we can add it to an entire timeline!
//         scrollTrigger: {
//           trigger: ".scene-evidence",

//           start: "top 70%", // when the top of the trigger hits the top of the viewport
//           // markers: true,
//         },
//       })
//       .to(".scene-evidence--wrapper", {
//         y: 0,
//         opacity: 1,
//       });
//     drawSvgLine();
//   }

//   let resizeTimer;
//   const handleResize = () => {
//     clearTimeout(resizeTimer);
//     resizeTimer = setTimeout(() => {
//       drawSvgLine();
//     }, 350);
//   };

//   window.addEventListener("resize", handleResize);
// }
